import { AppDispatch } from "../..";
import { fetchSurveyDetailsOperation } from "../reducers";
import { surveyDetails } from "../api/surveyDetails";
import { actionCreators as surveyActionCreators } from "../reducers/survey";

export const fetchSurveyDetails = (dispatch: AppDispatch, locationId?: string, partyId?: string) => {
    if (!locationId || !partyId) {
        return null;
    }

    return fetchSurveyDetailsOperation.invoke(async () => {
        const fetchedSurveyDetails = await surveyDetails(locationId, partyId);
        dispatch(surveyActionCreators.setDetails(fetchedSurveyDetails));
        return fetchedSurveyDetails;
    }, dispatch);
};
